import {
  parsePhoneNumber,
  formatIncompletePhoneNumber,
  type CountryCode,
  parsePhoneNumberWithError,
} from 'libphonenumber-js'

export const validPhoneNumber = (value: string, country?: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, (country as CountryCode) || 'US')

    return numberInfo.isValid()
  } catch (e) {
    return false
  }
}

export const formatPhoneNumberNational = (value: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, 'US')

    return numberInfo.formatNational()
  } catch (e) {
    return value
  }
}

export const formatPhoneNumberNationalWithCode = (value: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, 'US')
    return `+${numberInfo.countryCallingCode} ${numberInfo.formatNational()}`
  } catch (e) {
    return value
  }
}

export const formatPhoneNumberInternational = (value: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, 'US')
    return numberInfo.formatInternational()
  } catch (e) {
    return value
  }
}

export const formatPhoneNumberNationalNumber = (value: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, 'US')

    return numberInfo.nationalNumber
  } catch (e) {
    return value
  }
}

export const formatPhoneNumberIncomplete = (value: string) => {
  try {
    return formatIncompletePhoneNumber(value, 'US')
  } catch (e) {
    return value
  }
}

export const formatPhoneNumberInternationalNational = (value: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, 'US')
    return Number(numberInfo.nationalNumber)
  } catch (e) {
    return Number(value)
  }
}

export const formatPhoneNumberToInternational = (value: string) => {
  try {
    const numberInfo = parsePhoneNumber(value, 'US')
    return numberInfo.number.toString()
  } catch (e) {
    return value
  }
}

export const formatPhoneNumberByCountry = (value: string) => {
  try {
    const numberInfo = parsePhoneNumberWithError(value, 'US')
    const isUsOrCanada = numberInfo.country === 'US' || numberInfo.country === 'CA'

    return isUsOrCanada ? numberInfo.formatNational() : numberInfo.number.toString()
  } catch (e) {
    return value
  }
}
